import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import EyeIcon from '../../ui/icons/EyeIcon'
import TrashIcon from '../../ui/icons/TrashIcon'
import Chip from '../../ui/Chip'
import Tooltip from '../../ui/Tooltip'
import formatBytes from '../../../utils/formatBytes'
import { formatDateTime } from '../../../utils/dateHelpers'

const BADGE_CLASS = 'tw:absolute tw:top-1 tw:left-1'
const SIGNED_ID = 'signed_id'
const BYTE_SIZE = 'byte_size'
const CREATED_AT = 'created_at'
const SPHERICAL_PHOTO = 'spherical_photo'

const CARD_CLASS = 'tw:flex tw:items-stretch tw:overflow-hidden tw:rounded-lg! '
  + 'tw:border tw:border-solid tw:border-gray-300 tw:bg-white tw:pr-3'
const THUMB_CLASS = 'tw:relative tw:w-13 tw:shrink-0 tw:border-r tw:border-solid tw:border-gray-300'
const ACTION_CLASS = 'tw:flex tw:items-center tw:justify-center tw:size-10 tw:shrink-0 '
  + 'tw:border-0 tw:bg-transparent tw:cursor-pointer'

const PhotoRow = ({ photo, readonly, onDelete, onView }) => {
  const handleView = useCallback(() => onView(photo), [photo, onView])
  const handleDelete = useCallback(() => onDelete(photo), [photo, onDelete])

  return (
    <div className={CARD_CLASS}>
      <div className={THUMB_CLASS}>
        <img
          alt={photo.filename}
          className="tw:absolute tw:inset-0 tw:size-full tw:object-cover"
          src={photo.url}
        />
        {photo[SPHERICAL_PHOTO] ? <Chip className={BADGE_CLASS} variant="success">360°</Chip> : null}
      </div>
      <div className="tw:flex tw:flex-1 tw:min-w-0 tw:flex-col tw:justify-center tw:gap-0.5 tw:py-2 tw:pl-3">
        <span className="tw:truncate tw:text-sm tw:text-gray-950">{photo.filename}</span>
        <span className="tw:text-sm tw:text-gray-600">{`Le ${formatDateTime(photo[CREATED_AT])}`}</span>
        <span className="tw:text-sm tw:text-gray-600">{formatBytes(photo[BYTE_SIZE])}</span>
      </div>
      <Tooltip className="tw:flex tw:items-center tw:shrink-0 tw:self-center" content="Voir">
        <button
          aria-label="Voir la photo"
          className={`${ACTION_CLASS} tw:text-2xl! tw:text-gray-600`}
          type="button"
          onClick={handleView}
        >
          <EyeIcon />
        </button>
      </Tooltip>
      {readonly ? null : (
        <Tooltip className="tw:flex tw:items-center tw:shrink-0 tw:self-center" content="Supprimer">
          <button
            aria-label="Supprimer la photo"
            className={`${ACTION_CLASS} tw:text-xl! tw:text-ds-danger`}
            type="button"
            onClick={handleDelete}
          >
            <TrashIcon />
          </button>
        </Tooltip>
      )}
    </div>
  )
}

PhotoRow.propTypes = {
  onDelete: PropTypes.func.isRequired,
  onView: PropTypes.func.isRequired,
  photo: PropTypes.shape({
    [BYTE_SIZE]: PropTypes.number,
    [CREATED_AT]: PropTypes.string,
    filename: PropTypes.string,
    [SIGNED_ID]: PropTypes.string,
    [SPHERICAL_PHOTO]: PropTypes.bool,
    url: PropTypes.string
  }).isRequired,
  readonly: PropTypes.bool
}

PhotoRow.defaultProps = {
  readonly: false
}

export default PhotoRow
